import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { config } from './config';
//import CryptoJS = require('crypto-js');
@Injectable()
export class EncryptService {

  constructor() { }

  encryptPassword(password){
  	return new Promise((resolve, reject) => {
  		
    	var encrypted = CryptoJS.AES.encrypt(password, config.key);
  		resolve({"encrypted":encrypted.toString()})
  	});
  }

  decryptPassword(encrypted){
  	return new Promise((resolve, reject) => {
  		var bytes  = CryptoJS.AES.decrypt(encrypted, config.key);
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  		resolve({"decrypted":plaintext})
  	});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/encrypt/encrypt.service.ts